export enum IntegrationType {
    Hris = 0,
    Lims = 1,
    GalsonLab = 2,
    AlsLab = 3,
    OtherLab = 4,
}

export enum AllowedIntegrationType {
    Lims = 1,
    GalsonLab = 2,
    AlsLab = 3,
    OtherLab = 4,
}
